import MarketplaceCta from './MarketplaceCta';

export default MarketplaceCta;
export { MarketplaceCta };
